import { Location } from 'history'

export const getRandom = (length: number): string => {
  return Math.random().toString(36).substring(length)
}

export const getUriWithQueryStringValue = (location: Location, key: string, value?: string) => {
  const uri = `${location.pathname}${location.search}`

  const newKvp = `${key}=${value}`
  const find = new RegExp(`([&?]{1})${key}=[^&]*`)
  const replace = value === undefined ? '' : `$1${newKvp}`

  let newUri = `${uri.match(find) ? uri.replace(find, replace) : `${uri}${value === undefined ? '' : `${uri.includes('?') ? '&' : '?'}${newKvp}`}`}`
  newUri = newUri.replace(/^([^?]*)&(.*)$/, '$1?$2')

  return newUri
}
